import { FC } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IDropdownTrigger } from '../../types';
import Button from '../form/button';

const DropdownTrigger: FC<IDropdownTrigger> = (props) => {

  const {
    id,
    handleToggle,
    hideArrow = false,
    children,
    ...rest
  } = props;

  return (
    <div className="dropdown-trigger">
      <Button
        aria-haspopup="true"
        aria-controls={id}
        onClick={handleToggle}
        {...rest}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

          {children}

          {!hideArrow && (
            <FontAwesomeIcon
              icon={faCaretDown as IconProp}
              style={{
                position: 'absolute',
                right: '1rem',
              }}
            />
          )}

        </div>
      </Button>
    </div>
  );

};

export default DropdownTrigger;
